// extracted by mini-css-extract-plugin
export default {"action-button":"ActionButton_action-button__5fYt8 ButtonText_button-text__55tKw","action-button__title":"ActionButton_action-button__title__6rk6H"};